import { z } from 'zod'

import { getErrorLogMessage } from './get-error-log-message.ts'

export const hasMessage = (data: unknown): data is { message: string } =>
  z.object({ message: z.string() }).safeParse(data).success

export const getLogMessage = (data: unknown, defaultMessage?: string) => {
  if (data instanceof Error) {
    return getErrorLogMessage(data)
  }

  if (hasMessage(data)) {
    return data.message
  }

  return defaultMessage ?? 'an unknown error has occurred'
}
